export default {
  methods: {
    checkType(error, type) {
      return error && error[type] ? 'is-danger' : '';
    },
    displayError(error, type) {
      return error && error[type] ? error[type].join(' ') : '';
    }
  }
};
